class LeadConst {
  static Refresh = 'refresh';
  static Call = 'call';
  static Meeting = 'meeting';
  static Document = 'document';
  static SMS = 'sms';
  static Email = 'email';
  static WhatsApp = 'whats-app';
  static Service = 'service';
  static SalesOrder = 'sales-order';
  static Quote = 'quote';
  static Contact = 'contact';
  static CloudCall = 'CloudCall';
  static Note = 'note';
  static History = 'history';
  static Task = 'task';
  static Ticket = 'ticket';
  static Property = 'property';

  static Edit = 'edit';
  static Delete = 'delete';

  static Previous = 1;
  static Next = 2;

  static SearchLead = 'module-search-lead';
  static MinBudget = 'min_budget';
  static PropertyTransaction = 'property_transaction';
  static PropertyType = 'property_type';
  static PropertyIs = 'property_is';

  static TabView = 1;
  static ListView = 2;
  static CompactView = 3;
  static ModernView = 4;
}
export default LeadConst;